import { getUserFromStorage } from "@/shared/helpers/storageHelpers";

export const getTableName = (name: string) => {
  const user = getUserFromStorage();
  const username = user?.fullName?.replace(" ", "_");
  if (username) {
    return `${username}-${name}`;
  }
};
